import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import checkNotIcon from '../../../../../../../assetss/img/checkNotIcon.svg'
import './index.scss'

const AcceptRequestMessage = ({ newContent, name, isMobile }) => (
  newContent ? (
    <Grid className='wrapperNewAvtorRequestMessage'>
      <Grid className='newAvtorRequestMessage'>
        <img className='checkIcon' src={checkNotIcon} />
        <Typography className='newTextBox'>
          <span>
            {name} accepted your meeting request.<br />
            Now you can schedule the meeting {isMobile ? 'by clicking on' : 'in'}<br />
            {isMobile ? '"Schedule meeting" button.' : 'the form on the right side of the screen.'}<br />
            <br />
          </span>
          <span>
            <span className='impText'>Important:</span> As the initiator of the meeting you should schedule it.
          </span>
        </Typography>
      </Grid>
    </Grid>
  ) : (
    <Grid className='wrapperAvtorRequestMessage'>
      <Grid className='avtorRequestMessage'>
        <img className='checkIcon' src={checkNotIcon} />
        <Grid className='textBox'>
          <Typography className='topText'>
            {isMobile ? (
              `${name}accepted your meeting request. Schedule the meeting by clicking on Schedule meeting button`
            ) : (`${name} accepted your meeting requet. Schedule the meeting by using the form in the right panel.`)}
          </Typography>
          <Typography className='bottomText'><span>Important:</span> Only you, as an initiator, can schedule the meeting.</Typography>
        </Grid>
      </Grid>
    </Grid>
  )
)

export default AcceptRequestMessage
